import { type Message, MessageContentType } from '@/features/messages';
import MessageCompose from '@/features/messages/components/message-compose/message-compose';
import { memo } from 'react';
import { MessageListItemText } from './message-list.item.text';

interface MessageListItemProps {
  message: Message;
  curUserId?: string;
  mode?: 'compact' | 'comfortable';
  isLast?: boolean;
}

export const MessageListItem = memo<MessageListItemProps>(({ message, curUserId, mode, isLast }) => {
  const isCurUser = message.senderId === curUserId;

  if (message.isRevoked) {
    return (
      <MessageListItemText
        mode={mode}
        message={{
          ...message,
          content: 'Tin nhắn này đã bị thu hồi',
          reactions: {},
          parentMessage: undefined
        }}
        isCurUser={isCurUser}
        isLast={isLast}
      />
    );
  }

  switch (message.contentType) {
    case MessageContentType.TEXT:
      return <MessageListItemText mode={mode} message={message} isCurUser={isCurUser} isLast={isLast} />;

    case MessageContentType.COMPOSE:
    case MessageContentType.COMBINE:
      return <MessageCompose mode={mode} message={message} isCurUser={isCurUser} isLast={isLast} />;
    default:
      return <MessageListItemText mode={mode} message={message} isCurUser={isCurUser} isLast={isLast} />;
  }
});

MessageListItem.displayName = 'MessageItem';
